/**
 * Define a regex to validate a string contains only numbers
 */
export const onlyNumbersRegex = /^-?(\d+\.?\d*)$|(\d*\.?\d+)$/;
